import { FaRegUser, FaSearchengin } from "react-icons/fa6";
import { LazyLoadImage } from "react-lazy-load-image-component";
import { useEffect, useState } from "react";
import axios from "axios";
import { IoMdShare } from "react-icons/io";
import NotFound from "../shared/NotFound";
import { SlCalender } from "react-icons/sl";
import { TbCategory2 } from "react-icons/tb";
import { LuMapPin } from "react-icons/lu";

export default function Content() {
    const [data, setData] = useState<any[]>([]);
    const [pagination, setPagination] = useState<any>({});
    const [search, setSearch] = useState<string>('');
    const [category, setCategory] = useState<string>('');
    const [currentPage, setCurrentPage] = useState<number>(1);
    const [status, setStatus] = useState<string>('');

    const getData = async (page: number = 1, search: string = '', category: string = '', status: string = '') => {
        try {
            const response = await axios.get(
                `${process.env.REACT_APP_API_ENDPOINT}/auction?page=${page}&search=${search}&category=${category}&status=${status}`
            );
            if (response && response.data && response.data.data) {
                setData(response.data.data.data);
                setPagination(response.data.data);
            } else {
                setData([]);
            }
        } catch (error) {
            console.error("Error fetching data:", error);
        }
    };

    const handlePageChange = (page: number) => {
        setCurrentPage(page);
    };

    const handleSearchChange = (event: React.ChangeEvent<HTMLInputElement>) => {
        const newUrl = window.location.pathname;
        window.history.pushState({}, '', newUrl);
        setSearch(event.target.value);
    };

    const handleCategoryClick = (category: string) => {
        if (category === '') {
            setStatus('');
            setSearch('');
            const newUrl = window.location.pathname;
            window.history.pushState({}, '', newUrl);
        }
        setCategory(category);
    };

    const handleStatusClick = (status: string) => {
        setStatus(status);
    }

    const handleCopyLink = (search: string) => {
        const linkToCopy = `${window.location.origin}${window.location.pathname}?search=${search}`;

        navigator.clipboard.writeText(linkToCopy)
            .then(() => alert("URL berhasil disalin!"))
            .catch((error) => console.error("Gagal menyalin URL:", error));
    };

    useEffect(() => {
        const searchParam = new URLSearchParams(window.location.search).get('search') || '';
        setSearch(searchParam);
        getData(currentPage, searchParam, category, status);
    }, []);

    useEffect(() => {
        getData(currentPage, search, category, status);

    }, [currentPage, search, category, status]);

    const categories = [
        { label: 'All', value: '' },
        { label: 'Bangunan', value: 'bangunan' },
        { label: 'Tanah', value: 'tanah' },
    ];

    return (
        <div className="max-w-screen-2xl mx-auto pt-16 pb-60 p-5 md:p-5 lg:p-16">
            <div className="flex flex-col-reverse md:flex-row md:justify-between gap-8">
                {/* Konten Penawaran */}
                <div className="flex-grow grid gap-y-10 w-full lg:max-w-4xl">
                    {data.length === 0 ? (
                        <NotFound />
                    ) : (
                        data.map((item) => (
                            <div key={item.id} className="w-full h-full md:h-full rounded-xl overflow-hidden flex flex-col">
                                <div className="grid gap-4">
                                    {item.img_auction.length > 0 && (
                                        <a
                                            href={`${process.env.REACT_APP_API_ENDPOINT}/auction/getimg/${item.img_auction[0].img_auction}`}
                                            target="_blank"
                                            rel="noopener noreferrer"
                                        >
                                            <LazyLoadImage
                                                src={`${process.env.REACT_APP_API_ENDPOINT}/auction/getimg/${item.img_auction[0].img_auction}`}
                                                alt={item.title}
                                                effect="blur"
                                                className="h-auto max-w-full rounded-lg"
                                            />
                                        </a>
                                    )}
                                    {item.img_auction.length > 1 && (
                                        <div className="grid grid-cols-5 gap-4">
                                            {item.img_auction.slice(1, 6).map((img: any, index: number) => (
                                                <a
                                                    key={index}
                                                    href={`${process.env.REACT_APP_API_ENDPOINT}/auction/getimg/${img.img_auction}`}
                                                    target="_blank"
                                                    rel="noopener noreferrer"
                                                >
                                                    <LazyLoadImage
                                                        src={`${process.env.REACT_APP_API_ENDPOINT}/auction/getimg/${img.img_auction}`}
                                                        alt={`Gambar ${index + 1}`}
                                                        effect="blur"
                                                        className="h-auto max-w-full rounded-lg"
                                                    />
                                                </a>
                                            ))}
                                        </div>
                                    )}
                                </div>
                                <div className="p-3">
                                    <div className="flex flex-row space-x-2">
                                        <span
                                            className={`font-poppinsRegular py-1 px-4 rounded-md ${item.status === "lelang"
                                                ? "text-[#27AE60] bg-green-100 rounded-2xl"
                                                : item.status === "terjual"
                                                    ? "text-red-500 bg-red-100 rounded-2xl"
                                                    : "bg-gray-300 text-gray-700"
                                                }`}
                                        >
                                            {item.status.charAt(0).toUpperCase() + item.status.slice(1)}
                                        </span>
                                    </div>

                                    <div className="flex justify-between items-center mb-2 mt-8">
                                        <div className="flex items-center space-x-2 text-[#B9B9B9]">
                                            <FaRegUser /> <span className="text-sm" dangerouslySetInnerHTML={{ __html: item.author.name }}></span>
                                        </div>
                                        <IoMdShare
                                            className="text-2xl cursor-pointer text-bprDarkBlue hover:text-blue-500"
                                            title="Share"
                                            onClick={() => handleCopyLink(item.title)}
                                        />
                                    </div>
                                    <div className="flex flex-row space-x-2 text-[#B9B9B9]">
                                        <SlCalender />
                                        <span className="text-sm">Publish: {new Intl.DateTimeFormat('id-ID', { day: 'numeric', month: 'long', year: 'numeric' }).format(new Date(item.created_at))}</span>
                                    </div>
                                    <div className="flex flex-row space-x-2 text-[#B9B9B9]">
                                        <TbCategory2 />
                                        <span className="text-sm">Kategori: {item.category}</span>
                                    </div>
                                    <div className="font-poppinsBold text-lg mt-2 mb-4">{item.title}</div>
                                    <p className="text-textPrimary mt-3">
                                        <a
                                            href={`https://www.google.com/maps/search/?api=1&query=${encodeURIComponent(item.address)}`}
                                            target="_blank"
                                            rel="noopener noreferrer"
                                            className="text-blue-600 hover:underline"
                                        >
                                            <div className="flex items-center space-x-2">
                                                <LuMapPin /><span>lihat di google map</span>
                                            </div>
                                        </a>
                                    </p>

                                    <div className="mt-10">
                                        <span className="text-3xl font-poppinsBold text-blue-500">Rp {item.limit_price}</span>
                                    </div>
                                    <div className="items-center mt-10 flex flex-row space-x-24">
                                        <div className="flex flex-row space-x-2 items-center">
                                            <span className="text-2xl font-poppinsBold text-[#B9B9B9]">LT</span>
                                            <span className="text-md text-gray-600">{item.lt} m²</span>
                                        </div>
                                        <div className="flex flex-row space-x-2 items-center">
                                            <span className="text-2xl font-poppinsBold text-[#B9B9B9]">LB</span>
                                            <span className="text-md text-gray-600">{item.lb} m²</span>
                                        </div>
                                    </div>
                                    <div className="pt-2 flex justify-between mb-8 mt-5 ">
                                        <a
                                            href={item.status === 'terjual' ? '#' : ` https://wa.me/082290644363/?text=halo admin saya tertarik dengan ${encodeURIComponent(item.title)}`}
                                            target="_blank"
                                            rel="noopener noreferrer"
                                            className={`w-full font-poppinsBold text-sm py-5 px-4 rounded-md ${item.status === 'terjual' ? 'bg-red-500 cursor-not-allowed' : 'bg-green-500 hover:bg-green-600'} text-white transition-all duration-200 text-center`}
                                            style={{ pointerEvents: item.status === 'terjual' ? 'none' : 'auto' }}
                                        >
                                            {item.status === 'terjual' ? 'Terjual' : 'Hubungi Kami via WhatsApp'}
                                        </a>
                                    </div>
                                </div>
                            </div>
                        ))
                    )}
                    <div className="mt-10">
                        {pagination.total > 0 && (
                            <nav aria-label="Page navigation example" className="flex justify-end">
                                <ul className="inline-flex -space-x-px text-base h-10">
                                    <li>
                                        <button
                                            onClick={() => handlePageChange(pagination.current_page - 1)}
                                            disabled={!pagination.prev_page_url}
                                            className="flex items-center justify-center px-4 h-10 leading-tight text-gray-500 bg-white border border-e-0 border-gray-300 rounded-s-lg hover:bg-gray-100 hover:text-gray-700"
                                        >
                                            &laquo; Previous
                                        </button>
                                    </li>
                                    {pagination.links && pagination.links.map((link: any, index: number) =>
                                        link.url && link.label !== '&laquo; Previous' && link.label !== 'Next &raquo;' ? (
                                            <li key={index}>
                                                <button
                                                    onClick={() =>
                                                        handlePageChange(Number(new URL(link.url).searchParams.get('page')))
                                                    }
                                                    className={`flex items-center justify-center px-4 h-10 leading-tight ${link.active ? 'text-blue-600 bg-blue-50' : 'text-gray-500 bg-white'
                                                        } border border-gray-300 hover:bg-gray-100 hover:text-gray-700`}
                                                >
                                                    {link.label}
                                                </button>
                                            </li>
                                        ) : null
                                    )}
                                    <li>
                                        <button
                                            onClick={() => handlePageChange(pagination.current_page + 1)}
                                            disabled={!pagination.next_page_url}
                                            className="flex items-center justify-center px-4 h-10 leading-tight text-gray-500 bg-white border border-e-0 border-gray-300 rounded-e-lg hover:bg-gray-100 hover:text-gray-700"
                                        >
                                            Next &raquo;
                                        </button>
                                    </li>
                                </ul>
                            </nav>
                        )}
                    </div>
                </div>
                {/* Sidebar Pencarian */}
                <div className="border p-8 w-full md:sticky top-24 h-full md:w-1/3">
                    <span className="flex text-xl font-poppinsBold">Pencarian</span>
                    <div className="relative w-full sm:w-auto mt-5">
                        <input
                            type="text"
                            placeholder="Search..."
                            className={`py-2 pl-10 pr-3 rounded-lg border border-gray-300 focus:outline-none focus:ring-2 focus:ring-bprDarkBlue text-sm w-full`}
                            value={search}
                            onChange={handleSearchChange}
                        />

                        <span className="absolute left-3 top-1/2 transform -translate-y-1/2 text-gray-500">
                            <FaSearchengin className="text-sm" />
                        </span>
                    </div>
                    <span className="flex text-xl font-poppinsBold mt-5">Kategori</span>
                    <div className="mt-4 overflow-x-auto flex space-x-3">
                        {categories.map((categoryItem) => (
                            <button
                                key={categoryItem.value}
                                onClick={() => handleCategoryClick(categoryItem.value)}
                                className={`py-1 px-3 rounded ${category === categoryItem.value ? 'bg-bprDarkBlue text-white' : 'bg-white text-bprDarkBlue border border-bprDarkBlue'}`}
                            >
                                {categoryItem.label}
                            </button>
                        ))}
                    </div>
                    <span className="flex text-xl font-poppinsBold mt-5">Status</span>
                    <div className="mt-4 space-y-2">
                        <label className="flex items-center space-x-2">
                            <input
                                type="checkbox"
                                checked={status === ''}
                                onChange={() => handleStatusClick('')}
                                className="form-checkbox h-4 w-4 text-bprDarkBlue"
                            />
                            <span className="text-sm">All</span>
                        </label>
                        <label className="flex items-center space-x-2">
                            <input
                                type="checkbox"
                                checked={status === 'lelang'}
                                onChange={() => handleStatusClick('lelang')}
                                className="form-checkbox h-4 w-4 text-bprDarkBlue"
                            />
                            <span className="text-sm">Lelang</span>
                        </label>
                        <label className="flex items-center space-x-2">
                            <input
                                type="checkbox"
                                checked={status === 'terjual'}
                                onChange={() => handleStatusClick('terjual')}
                                className="form-checkbox h-4 w-4 text-bprDarkBlue"
                            />
                            <span className="text-sm">Terjual</span>
                        </label>
                    </div>
                </div>
            </div>
        </div>
    );
}
